/*
 ** Config for attachments
 */

const attachmentRules = [{
  main: 'Alta - Beneficiarios EsSalud',
  codeGTM: 'REABE',
  attachments: [
    // { name: 'Guía de AltaESSALUD', attach: false, downloadable: true, fileurl: 'guias/guia-solicitud-de-alta-baja-de-beneficiario-para-essalud.pdf' },
    // { name: 'Copia de DNI', attach: true, downloadable: false },
    { id: 1, name: 'DNI del beneficiario', attach: true, downloadable: false },
    { id: 2, name: 'Documentos adicionales', attach: true, downloadable: false }
  ]
},
{
  main: 'Baja - Beneficiarios EsSalud',
  codeGTM: 'REBBE',
  attachments: [
    // { name: 'Guía de AltaESSALUD', attach: false, downloadable: true, fileurl: 'guias/guia-solicitud-de-alta-baja-de-beneficiario-para-essalud.pdf' },
    // { name: 'Copia de DNI', attach: true, downloadable: false },
    { id: 1, name: 'Acta de defunción del beneficiario', attach: true, downloadable: false }
    // { name: 'Copia del DNI del solicitante', attach: true, downloadable: false }
  ]
},
{
  main: 'Aviso de fallecimiento',
  codeGTM: 'READF',
  attachments: [
    // { name: 'Requisitos', attach: false, downloadable: true, fileurl: 'guias/guia-solicitud-de-aviso-de-fallecimiento.pdf' },
    // { name: 'Copia de DNI', attach: true, downloadable: false },
    { id: 1, name: 'Acta de defunción del beneficiario', attach: true, downloadable: false }
  ]
},
{
  main: 'Modificar número de cuenta',
  codeGTM: 'RECNC',
  attachments: [
    // { name: 'Requisitos', attach: false, downloadable: true, fileurl: 'guias/guia-solicitud-de-cambio-de-via-de-pago.pdf' },
    // { name: 'Copia de DNI de pensionista', attach: true, downloadable: false },
    // { name: 'Formato firmado de cambio de vía de pago', attach: true, downloadable: true, fileurl: 'formatos/formato_solicitud_cambio_via_de_pago.pdf' },
    // { name: 'Voucher del banco donde figure número de cuenta', attach: true, downloadable: false }
  ]
},
  /*
    {
      main: 'Herencias',
      codeGTM: 'REHER',
      attachments: [
        { name: 'Guía de solicitud de herencia', attach: false, downloadable: true, fileurl: 'guias/guia-solicitud-de-pago-de-herencia.pdf' },
        { name: 'Acta de defunción afiliado / último beneficiario', attach: true, downloadable: false },
        { name: 'Copia de DNI de herederos legales', attach: true, downloadable: false },
        { name: 'Solicitud firmada de pago de Período Garantizado', attach: true, downloadable: true, fileurl: 'formatos/formato-solicitud-pago-de-herencia.pdf' },
        { name: 'Inscripción en registros públicos – representante legal', attach: true, downloadable: false },
        { name: 'Sucesión del asegurado titular fallecido inscrita en registros públicos', attach: true, downloadable: false },
        { name: 'Asiento de la inscripción de sucesión del asegurado titular fallecido', attach: true, downloadable: false }
      ]
    },
    */
{
  main: 'Inclusión de beneficiario',
  codeGTM: 'REIBP',
  attachments: [
    // { name: 'Guía de Inclusión de Beneficiario', attach: false, downloadable: true, fileurl: 'guias/guia-solicitud-inclusión-exclusión beneficiario.pdf' },
    // { name: 'Copia de DNI', attach: true, downloadable: false },
    // { name: 'Carta simple - Inclusión del beneficiario', attach: true, downloadable: false },
    { id: 1, name: 'DNI del beneficiario', attach: true, downloadable: false },
    { id: 2, name: 'Adicional según parentesco', attach: true, downloadable: false }
  ]
},
{
  main: 'Exclusión de beneficiario',
  codeGTM: 'REEBP',
  attachments: [
    // { name: 'Guía de Exclusión de Beneficiario', attach: false, downloadable: true, fileurl: 'guias/guia-solicitud-inclusión-exclusión beneficiario.pdf' },
    // { name: 'Copia de DNI', attach: true, downloadable: false },
    // { name: 'Carta simple - Exclusión del beneficiario', attach: true, downloadable: false },
    { id: 1, name: 'Adicional según parentesco', attach: true, downloadable: false }
  ]
},
{
  main: 'Pensión de Sobrevivencia',
  codeGTM: 'REPDS',
  attachments: [
    { name: 'Requisitos', attach: true, downloadable: true, fileurl: 'guias/guia-solicitud-de-pensión-de-sobrevivencia.pdf' },
    { name: 'Solicitud firmada de pensión de sobrevivencia', attach: false, downloadable: true, fileurl: 'formatos/formato-solicitud-pago-de-renta-de-sobrevivencia.pdf' },
    { name: 'Copia de DNI de los beneficiarios', attach: true, downloadable: false },
    { name: 'Copia del acta de defunción', attach: true, downloadable: false },
    { name: 'Adicional según parentesco', attach: true, downloadable: false }
  ]
},
{
  main: 'Renovar Certificado de Estudios',
  codeGTM: 'RERCE',
  attachments: [
    // { name: 'Guía de renovación de certificados', attach: false, downloadable: true, fileurl: 'guias/guia-solicitud-de-renovacion-certificado-de-estudios.pdf' },
    // { name: 'Solicitud de certificado de estudios', attach: true, downloadable: true, fileurl: 'formatos/formato-solicitud-de-renovacion-de-certificado-de-estudios.pdf' },
    // { name: 'Copia de DNI', attach: true, downloadable: false },
    // { name: 'Declaración jurada de primera carrera', attach: true, downloadable: false },
    { id: 1, name: 'Constancia de matrícula', attach: true, downloadable: false },
    { id: 2, name: 'Malla curricular', attach: true, downloadable: false },
    { id: 3, name: 'Record de notas', attach: true, downloadable: false }
  ]
},
  /*
    {
      main: 'Renovación de Certificados de Supervivencia',
      attachments: [
        { name: 'Guía de renovación de certificados', attach: false, downloadable: true, fileurl: 'guias/guia-solicitud-de-renovacion-certificado-de-supervivencia.pdf' },
        { name: 'Copia del documento de Identidad diferente a DNI', attach: true, downloadable: false },
        { name: 'Certificado de supervivencia', attach: true, downloadable: true, fileurl: 'formatos/formato-solicitud-de-renovacion-de-certificado-de-supervivencia.pdf' }
      ]
    },
    */
{
  main: 'Préstamos',
  codeGTM: 'VIPRE',
  attachments: [
    { name: 'Copia de DNI', attach: true, downloadable: false }
  ]
},
{
  main: 'Anulación de póliza',
  codeGTM: 'VIADP',
  attachments: [
    // { name: 'Copia de DNI', attach: true, downloadable: false },
    // { name: 'Carta de anulación', attach: true, downloadable: false }
  ]
},
{
  main: 'Endoso a entidad financiera',
  codeGTM: 'VIEEF',
  attachments: []
},
{
  main: 'Cambio Frecuencia de Pago',
  codeGTM: 'VICFP',
  attachments: []
},
{
  main: 'Cuota comodín',
  codeGTM: 'VICCM',
  attachments: []
},
{
  main: 'Liberación de endoso',
  codeGTM: 'VILE',
  attachments: []
},
{
  main: 'Modificación de Beneficiarios',
  codeGTM: 'MDB',
  attachments: []
},
{
  main: 'Eliminación de cobertura',
  codeGTM: 'VIRCA',
  attachments: []
},
  /*
    ,
    {
      main: 'Devolución por anulación de póliza',
      attachments: [
        { name: 'Copia de DNI', attach: true, downloadable: false },
        { name: 'Carta de anulación', attach: true, downloadable: true, fileurl: 'solicitud_de_anulación_de_poliza.docx' }
      ]
    }
    */
]

export default attachmentRules



// WEBPACK FOOTER //
// ./src/interfaces/attachmentRules.js